module.exports = __webpack_public_path__ + "img/powered-by-klipy-image.9637077.png";